var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6875 1.91769C19.2572 1.91735 19.8365 2.06119 20.3645 2.36597C21.9689 3.2922 22.5187 5.34373 21.5925 6.94801L14.4049 19.397C13.4786 21.0012 11.427 21.5511 9.82278 20.6249C9.02153 20.1622 8.48281 19.4164 8.26083 18.5894L6.82425 13.2278L15.2284 8.37522C15.6867 8.11056 15.8439 7.52421 15.5794 7.06593C15.3147 6.60784 14.7283 6.45058 14.2701 6.71498L5.8659 11.5684L1.94082 7.64243C0.631045 6.33247 0.631389 4.20912 1.94082 2.89941C2.54664 2.29356 3.38664 1.91695 4.31234 1.91675L18.6875 1.91769Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/sendIcon.f6fd9fffdeadcb67021fe66361549025.svg";
export { ForwardRef as ReactComponent };